import React, { useState } from "react";

import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getUserDetailsApi, userResetPasswordApi } from "../../../Services/Login/LoginApi/loginApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function PasswordChange() {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [errors, setErrors] = useState({});
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(window.location.search);
 

  const userEmail = queryParams.get("email"); // Get the email from query params
  

  const userId = localStorage.getItem("user_id");
  

  const validateForm = () => {
    const validationErrors = {};
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(
        showNewPassword
      ) &&
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/.test(
        showConfirmPassword
      )
    ) {
      validationErrors.showNewPassword =
        "Password must contain at least 8 characters, including uppercase, lowercase, numerals, and symbols.";
    }
    if (showNewPassword !== showConfirmPassword) {
      validationErrors.showConfirmPassword = "Passwords do not match.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };
 
  async function getUserDetails(userId) {
    
    try {
      const token = localStorage.getItem("access_token"); // Assuming token is stored in localStorage
      
  
      // if (!token) {
      //   console.error("Authorization token not found!");
      //   return null;
      // }
     
      try {
       const res= await getUserDetailsApi(userId) ;
      
      return res.data;
        
      } catch (error) {
        
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
      return null;
    }
  }
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Object.values(errors).forEach((error) => {
        toast.error(error);
      });
      return;
    }

    try {
      

      const userDetails = await getUserDetails(userId);
      

      const result = await dispatch(
        userResetPasswordApi({
          email: userDetails?.data.email,
          old_password: oldPassword, //  Send old password for verification
          new_password: showNewPassword,
        })
      );

      if (userResetPasswordApi.fulfilled.match(result)) {
        toast.success("Password Reset Successfully", {
          onClose: () => navigate(-1),
        });
      } else {
        toast.error(
          result.payload?.message || "Password Reset failed! Try Again"
        );
      }
    } catch (error) {
      console.error("Password Reset error: ", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one setpw-page ">
        <div className="back-btn">
          <button onClick={() => navigate(-1)} className="back-btn-button">
            <ArrowBackIcon className="left-icon" />
            Back
          </button>
        </div>
        <div className="container-fluid p-0 m-0">
          <div
            className="row m-0 loginpage"
            style={{ justifyContent: "center" }}
          >
            <div className="col-10 login-cols-block change-pw">
              <div className="login-page-area setpw-area">
                <div className="login-information log-in">
                  {/* <h1 className="text-center mt-4">Change Password</h1> */}
                  <p className="pw-texts text-center">
                    {/* Your new password must be different to previously used
                    passwords. */}
                  </p>
                  <div className="form-login text-left">
                  <InputLabel htmlFor="new-password">
                        Current Password <span>*</span>
                      </InputLabel>
                    <Input
                      className="password-input-box"
                      id="old-password"
                      placeholder="Current Password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={oldPassword} //  Bind state
                      onChange={(event) => setOldPassword(event.target.value)} // Update state
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label={
                              showConfirmPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={() =>
                              setShowConfirmPassword((prev) => !prev)
                            }
                            onMouseDown={(event) => event.preventDefault()}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    <div className="mb-4">
                      <InputLabel htmlFor="new-password">
                        New Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="new-password"
                        placeholder="New Password"
                        type={showNewPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowNewPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showNewPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowNewPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showNewPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      <div className="pw-text-bottom">
                        {/* Password should be the combination of{" "} */}
                        <span>
                          {/* Uppercase & Lowercase Letters, Numerals and Symbols */}
                        </span>
                      </div>
                    </div>

                    <div className="mb-4">
                      <InputLabel htmlFor="confirm-password">
                        Confirm Password <span>*</span>
                      </InputLabel>
                      <Input
                        className="password-input-box"
                        id="confirm-password"
                        placeholder="Confirm Password"
                        type={showConfirmPassword ? "text" : "password"}
                        onChange={(event) =>
                          setShowConfirmPassword(event.target.value)
                        }
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label={
                                showConfirmPassword
                                  ? "hide the password"
                                  : "display the password"
                              }
                              onClick={() =>
                                setShowConfirmPassword((prev) => !prev)
                              }
                              onMouseDown={(event) => event.preventDefault()}
                            >
                              {showConfirmPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </div>
                    <div className="btn-orange">
                      <Button onClick={handleSubmit}>Change Password</Button>
                    </div>
                    <div className="lower-signup-text text-center">
                      {/* <p>
                        Need Help? <a href="">Click Here</a>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}

export default PasswordChange;
